import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=ts"

import "./LeftMenu.vue?vue&type=style&index=0&id=b460dcf4&lang=scss"

const __exports__ = script;

export default __exports__